if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        const activeSlide = this.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`);

        if (activeSlide && typeof product_modal_swiper !== 'undefined' && product_modal_swiper) {
          const slideIndex = Array.from(activeSlide.parentElement.children).indexOf(activeSlide);
          if (slideIndex >= 0) product_modal_swiper.slideTo(slideIndex, 0, false);
        }

        this.querySelectorAll('.swiper-slide.active').forEach((slide) => slide.classList.remove('active'));
        activeSlide?.classList.add('active');

        const activeMedia =
          activeSlide?.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.querySelector(`[data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector?.('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
